import { CashRegisterItem, Name } from '../interface/response/CashRegisterDataResponse';
import { fetchCashRegisterDetails } from '../store/slice/cash-register-details-slice';
import { fetchOperatorDetails } from '../store/slice/operator-details-slice';
import { useAppDispatch } from './useAppDispatch';
import { useAppSelector } from './useAppSelector';

/**
 * @function getCashRegisterDetails
 * @param {CashRegisterItem} item - The cash register item containing necessary identifiers or data for the fetch.
 *
 * Dispatches an action to fetch details of a cash register.
 *
 * @remarks
 * Assumes that `fetchCashRegisterDetails` is a Redux async action (thunk) that updates the store.
 *
 * @function getOperatorDetails
 * @param {Name} item - The operator data object containing identifiers such as name or ID.
 *
 * Dispatches an action to fetch details of an operator.
 *
 * @remarks
 * - Returns early if no `selectedItem` is set.
 * - Assumes that `fetchOperatorDetails` is a Redux async action (thunk) that updates the store.
 */

export const useFetchDetails = () => {
  const dispatch = useAppDispatch();

  const range = useAppSelector((state) => state.dateFilter);
  const selectedItem = useAppSelector((state) => state.cashRegisterData.selectedItem);

  const getCashRegisterDetails = (item: CashRegisterItem) => {
    dispatch(
      fetchCashRegisterDetails({
        LocationID: item.LocationID,
        DeviceID: item.DeviceID,
        From: range.from,
        To: range.to,
      }),
    );
  };

  const getOperatorDetails = (item: Name) => {
    if (!selectedItem) return;

    dispatch(
      fetchOperatorDetails({
        LocationID: selectedItem.LocationID,
        DeviceID: selectedItem.DeviceID,
        UserName: item.UserName,
        From: range.from,
        To: range.to,
      }),
    );
  };

  return { getCashRegisterDetails, getOperatorDetails };
};
